import Loader from 'components/Loader';
import useFileManagement from 'api/file-management/useFileManagement';
import FileItem from './FileItem';
import { FaUpload } from 'react-icons/fa6';
import { useState } from 'react';
import { useParams } from 'react-router';
import UploadFileForm from './UploadFileForm';
import { useKeyboard } from 'hooks/useKeyboard';
import { useSearchParams } from 'react-router-dom';
import { SettingsSection } from 'components/settingsHub/SettingsSection';
import { Scope } from 'components/settingsHub/ScopeFilter';
import { AddEntityCard } from 'components/settingsHub/EntityCard';
import { EntityGrid } from 'components/settingsHub/settingsEntities.styles';
import { SettingsDetailPanel } from 'components/settingsHub/SettingsDetailPanel';

type Props = {
  projectId?: string | null;
};

const FilesView = ({ projectId = null }: Props) => {
  const { projectId: routeProjectId } = useParams();
  const actualProjectId = projectId ?? routeProjectId;

  const [scope, setScope] = useState<Scope>(actualProjectId ? 'project' : 'global');
  const [uploadOpen, setUploadOpen] = useState(false);
  const [search, setSearch] = useState('');

  const includeGlobalFiles = scope === 'all' || scope === 'global';
  const { files, isLoading } = useFileManagement(actualProjectId, includeGlobalFiles);
  const [searchParams, setSearchParams] = useSearchParams();

  useKeyboard({
    keyDown: (e) => {
      if (e.key === 'Escape' && searchParams.get('config')) {
        if (uploadOpen) {
          setUploadOpen(false);
        } else {
          setSearchParams({});
        }
      }
    },
  });

  if (isLoading) return <Loader />;

  const query = search.trim().toLowerCase();
  const visibleFiles = (files ?? [])
    .filter((file) => {
      if (scope === 'project') return file.project_id && file.project_id === actualProjectId;
      if (scope === 'global') return !file.project_id;
      return true;
    })
    .filter((file) => !query || file.file_name.toLowerCase().includes(query))
    .sort((a, b) => b.created_at.localeCompare(a.created_at));

  return (
    <>
      <SettingsSection
        showScope={!!actualProjectId}
        scope={scope}
        onScopeChange={setScope}
        search={search}
        onSearchChange={setSearch}
        searchPlaceholder="Search files…"
        count={visibleFiles.length}
        countNoun="files"
      >
        <EntityGrid minTile={280}>
          <AddEntityCard
            label="Upload File"
            onClick={() => setUploadOpen(true)}
            icon={<FaUpload size={28} />}
            minHeight={224}
          />
          {visibleFiles.map((file) => (
            <FileItem key={file.id} file={file} />
          ))}
        </EntityGrid>
      </SettingsSection>

      {uploadOpen && (
        <SettingsDetailPanel onClose={() => setUploadOpen(false)}>
          <UploadFileForm onClose={() => setUploadOpen(false)} showGlobalOption inShell />
        </SettingsDetailPanel>
      )}
    </>
  );
};

export default FilesView;
